import axiosInstance from './axios-instance';
import { Store } from 'redux';
import { AxiosError } from 'axios';
import { sessionExpired } from '../../modules/login/action';

const setupInterceptors = (store: Store, instance = axiosInstance) => {
  instance.interceptors.response.use(
    res => {
      return res;
    },
    (error: AxiosError) => {
      if (error.response!.status === 401) {
        store.dispatch<any>(sessionExpired());
      }
      throw error;
    }
  );

  instance.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = 'Bearer ' + token;
    }
    return config;
  });
};

export default setupInterceptors;



// WEBPACK FOOTER //
// ./src/common/axios-instance/axios-interceptors.ts